import { render, staticRenderFns } from "./ListSchool.vue?vue&type=template&id=7cf5a14d"
import script from "./ListSchool.vue?vue&type=script&lang=js"
export * from "./ListSchool.vue?vue&type=script&lang=js"
import style0 from "./ListSchool.vue?vue&type=style&index=0&id=7cf5a14d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports